import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Login = () => {
    // const navigate = useNavigate();

    // useEffect(() => {
    //     const redirectToCognito = async () => {
    //         try {
    //             // Generate the Cognito Hosted UI URL
    //             const cognitoUrl = `https://auth.lostlogic.io/login?response_type=code&scope=openid%20email&client_id=6025mbahv0jiru600106dqoues&redirect_uri=${encodeURIComponent('http://localhost:3000/user-management')}`;
    //             window.location.href = cognitoUrl;
    //         } catch (error) {
    //             console.error("Error redirecting to Cognito:", error);
    //             // Handle the error (e.g., display an error message)
    //         }
    //     };

    //     redirectToCognito();
    // }, [navigate]);

    return ( ''
        // <div>
        //     <h2>Login</h2>
        //     <p>Redirecting to login...</p>
        // </div>
    );
};

export default Login;

// import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { Auth } from 'aws-amplify'; // Import Auth

// const Login = () => {
//      return (
//         <div>
//             <h2>Login</h2>
//             <p>Redirecting to login...</p>
//         </div>
//     );
// };

// export default Login;

